import React, { useState, useContext } from "react";
import { TextField, Divider, Button, Box } from "@mui/material";
import { DataContext } from "../../../context/DataContext";
import { simpleMessage } from "../../../helpers/Helpers";
import { deleteToken, deleteUserData, getToken } from "../../../api/Account";
import { isEmpty } from "lodash";
import { Stack } from "@mui/system";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave } from "@fortawesome/free-solid-svg-icons";
import { addPeriodicidadAsync } from "../../../api/Periodicidad";
import { accionPrincipalSx } from "../../../components/ui/accionPrincipal";

const AddPeriodicidad = ({ setShowModal }) => {
  const token = getToken();
  const { reload, setReload, setIsLoading, setIsLogged, setIsUnautorized } =
    useContext(DataContext);
  const [description, setDescription] = useState("");
  const [cantidadDias, setCantidadDias] = useState("");
  const [cuotaDias, setCuotaDias] = useState("");

  const saveChangesAsync = async () => {
    if (validate()) {
      const data = {
        description,
        cantidadDias,
        cuotaDias,
      };

      setIsLoading(true);
      const result = await addPeriodicidadAsync(token, data);
      if (!result.statusResponse) {
        setIsLoading(false);
        if (result.error === "eX01") {
          deleteUserData();
          deleteToken();
          setIsLogged(false);
          return;
        }

        if (result.error === "Unauthorized") {
          setIsUnautorized(true);
          return;
        }

        simpleMessage(result.error, "error");
        return;
      }

      setIsLoading(false);
      simpleMessage("Periodicidad Agregada...!", "success");
      setReload(!reload);
      setShowModal(false);
    }
  };

  //Devuelve un entero positivo
  const funtionSetCantidadDias = (value) => {
    if (/^[0-9]+$/.test(value.toString()) || value === "") {
      setCantidadDias(value);
      return;
    }
  };

  //Devuelve un entero positivo
  const funtionSetCuotaDias = (value) => {
    if (/^[0-9]+$/.test(value.toString()) || value === "") {
      setCuotaDias(value);
      return;
    }
  };

  //Validando campos ingresados
  const validate = () => {
    let isValid = true;
    if (isEmpty(description)) {
      simpleMessage("Debe ingresar una descripcion", "error");
      return (isValid = false);
    }

    if (isEmpty(cantidadDias)) {
      simpleMessage("Debe ingresar una cantidad de días", "error");
      return (isValid = false);
    }

    if (isEmpty(cuotaDias)) {
      simpleMessage("Debe ingresar cada cuantos días se cobra", "error");
      return (isValid = false);
    }

    if (cantidadDias === 0 || cuotaDias === 0) {
      simpleMessage("Debe ingresar una cantidad mayor que cero", "error");
      return (isValid = false);
    }
    return isValid;
  };

  return (
    <div>
      <Divider />

      <Box sx={{ width: '100%', maxWidth: 450 }}>
        <Stack spacing={2}>
          <TextField
            fullWidth
            required
            onChange={(e) => setDescription(e.target.value.toUpperCase())}
            value={description}
            label={"Descripcion Periocidad"}
          />
          <TextField
            fullWidth
            required
            onChange={(e) => funtionSetCantidadDias(e.target.value)}
            value={cantidadDias}
            label={"Cantidad de días"}
          />
          <TextField
            fullWidth
            required
            onChange={(e) => funtionSetCuotaDias(e.target.value)}
            value={cuotaDias}
            label={"Cuota días"}
          />

          <Button
            variant="contained"
            startIcon={
              <FontAwesomeIcon icon={faSave} />
            }
            onClick={() => saveChangesAsync()}
            sx={accionPrincipalSx}
          >
            Agregar Periocidad
          </Button>
        </Stack>
      </Box>
    </div>
  );
};

export default AddPeriodicidad;
